var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.handlePreview}},[_vm._v(" "+_vm._s(_vm.$t("FORMS.preview"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }